export default __webpack_public_path__ + "static/media/Detail-Chatbot.87129df7.png";